import { Badge } from "@roberttamas/ui";
import { useTranslation } from "react-i18next";

import type { OrderSnapshot } from "@/lib/types";

/** Storage size + duration as small tags — the scannable alternative to
 * jamming them into a sentence with the tier name. */
export function OrderPackageTags({ snapshot }: { snapshot: OrderSnapshot }) {
  const { t } = useTranslation();
  if (snapshot.storageGb === null && snapshot.months === null) return null;
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      {snapshot.storageGb !== null && (
        <Badge variant="secondary">{snapshot.storageGb} GB</Badge>
      )}
      {snapshot.months !== null && (
        <Badge variant="secondary">{t("orderStatus.months", { count: snapshot.months })}</Badge>
      )}
    </span>
  );
}
